"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VcMetadataParser_1 = require("./VcMetadataParser");
Object.defineProperty(exports, "VcMetadataParserFactory", { enumerable: true, get: function () { return VcMetadataParser_1.VcMetadataParserFactory; } });
//# sourceMappingURL=index.js.map